import React, { useState, forwardRef, useEffect, useMemo } from 'react';
import { Image, Dropdown } from 'react-bootstrap';
import './FilterableDropdown.scss';
import deleteSelectedButton from '../../assets/images/drop_down_delete_selected.png'
import NarrowUp from '../../assets/images/drop_down_not_show_narrow.svg';
import Search from '../../assets/images/drop_down_filter.svg';
import CustomTips from './CustomTips';
import { CheckboxItem } from './BaseFilter';
import { removeElementFromArray } from 'utils';

export const CustomToggle = forwardRef(({ children, onClick, disableDropDown }, ref) => (
  <div
    className="filterable-toogle-area"
    ref={ref}
    style={disableDropDown ? {
      "background-color": "#EEEEEE",
      "opacity": "0.6"
    } : {}}
    onClick={(e) => {
      e.preventDefault();
      if (disableDropDown) {
        return;
      }
      onClick(e);
    }}
  >
    {children}
  </div>
));

export const CustomMenu = forwardRef(
  (
    {
      children,
      style,
      className,
      'aria-labelledby': labeledBy,
      options,
      filter,
      filterButtons,
      filterAction,
      isLoadMore,
      placeholder,
      useCaution,
      cautionDetail,
    },
    ref,
  ) => {
    const [value, setValue] = useState('');
    const [filterBtn, setFilterBtn] = useState('');
    const [filteredList, setfilteredList] = useState(
      options.map((item) => item.label),
    );
    const getFilteredList = (filter1, filter2) => {
      // const prevList = options;
      // let filterList = prevList;
      // if (filter1) {
      //   filterList = filterList.filter((item) =>
      //     item.label.toLowerCase().includes(filter1.toLowerCase()),
      //   );
      // }
      // if (filter2) {
      //   filterList = filterList.filter(
      //     (item) =>
      //       item.value.subFilterField.toLowerCase() === filter2.toLowerCase(),
      //   );
      // }
      // setfilteredList(filterList.map((item) => item.label));
      filterAction(filter1);
      isLoadMore(false);
    };
    // console.log('@@127: ', options, filteredList);
    useEffect(() => {
      setfilteredList(options.map((item) => item.label));
    }, [options]);
    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        {filter ? (
          <div className='filterable-search-bar-caution-container'>
            <div className="filterable-search-bar">
              <Image src={Search} className="filterable-search-bar-icon" />
              <input
                autoFocus
                className="filterable-search-bar-input"
                placeholder={placeholder}
                onChange={(e) => {
                  setValue(e.target.value);
                  getFilteredList(e.target.value, filterBtn);
                }}
                value={value}
              />
            </div>
            {
              useCaution && (
                <CustomTips
                  detail={cautionDetail}
                  placement="bottom"
                  popoverClassName="list-filter-list-search-section-popover"
                />
              )
            }
          </div>
        ) : null}
        {filterButtons && filterButtons.length > 0 ? (
          <div className="filter-buttons-bar">
            {filterButtons.map((button) => {
              return (
                <button
                  className={`filter-btn ${filterBtn === button ? 'filter-btn-selected' : ''
                    }`}
                  onClick={() => {
                    setFilterBtn(button);
                    getFilteredList(value, button);
                  }}
                >
                  {button}
                </button>
              );
            })}
          </div>
        ) : null}
        <ul className="filterable-dropdown-menu-select-area">
          {React.Children.toArray(children).filter((child) => {
            return typeof child.props.children !== 'string' || filteredList.includes(child.props.children);
          })}
        </ul>
      </div>
    );
  },
);

// const EmptyMenu = forwardRef(
//   ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
//     const [value, setValue] = useState('');
//     return null;
//   },
// );

function FilterableDropdown(props) {
  const displaySelectAllAsItem = props.displaySelectAllAsItem || false;
  const onSelectAll = props.onSelectAll || (() => { });
  const needFilter = props.needFilter === undefined ? true : props.needFilter;
  const filterButtons = props.filterButtons || [];
  const placeholder = props.placeholder || "Please select";
  const dropDownSearchBarPlaceholder = props.dropDownSearchBarPlaceholder || "Search for...";
  const useCaution = props.useCaution || false;
  const cautionDetail = props.cautionDetail || null;
  const muitipleSelect = props.muitipleSelect || false;

  const alwaysHint = props.alwaysHint || null;
  const customClass = props.customClass;
  const onSelectChange = props.selectChange || (() => { });
  const onToggle = props.onToggle || (() => { });
  const disableDropDown = props.disableDropDown || false;
  const hideDeleteButton = props.hideDeleteButton || false;
  const showItemDescription = props.showItemDescription || false;

  // const options = props.options || [];
  const [options, setOptions] = useState(props.options);
  const [value, setValue] = useState(
    muitipleSelect
      ? props.defaultValue?.map((item) => item?.value?.pk) || []
      : props.defaultValue?.label,
  );
  const displayValues = useMemo(() => {
    if (muitipleSelect) {
      return options?.filter(
        option => value?.includes(option?.pk || option.value?.pk)
      )?.map((item) => item.label)
        ?.join(', ')
    }
    return value
  }, [muitipleSelect, value, options])

  const [isOpen, setIsOpen] = useState();
  const isPromptDropdown = props.isPromptDropdown || false;

  const filterAction = props.filterAction || (() => { });
  const loadMoreAction = props.loadMoreAction || (() => { });
  // eslint-disable-next-line no-unused-vars
  const [isLoadMore, setIsLoadMore] = useState(false);
  useEffect(() => {
    if (muitipleSelect) {
      setValue(props.defaultValue?.map((item) => item?.pk || item?.value?.pk));
    } else {
      setValue(props.defaultValue?.label || props.defaultValue?.value?.label);
    }
  }, [muitipleSelect, props.defaultValue]);

  useEffect(() => {
    setOptions(props.options);
  }, [props.options]);

  const getOptionLabel = (option) => (
    showItemDescription ? (
      <>
        <div className="filterable-item-container">
          <label className="filterable-item-title">
            {option?.label}
          </label>
          {option?.description ? (
            <>
              <label className="filterable-item-desc">
                {option.description}
              </label>
            </>
          ) : null}
        </div>
      </>
    ) : (
      option?.label
    )
  )

  return (
    <Dropdown
      show={isOpen}
      onToggle={(isOpen, e, metadata) => {
        if (disableDropDown) {
          setIsOpen(false);
        } else if (metadata.source !== 'select' || !muitipleSelect) {
          setIsOpen(isOpen);
        }
        onToggle();
      }}
      className={`${isPromptDropdown
          ? 'filterable-dropdown-area'
          : 'filterable-dropdown-area-prompt'
        } ${customClass}`}
      onScroll={(event) => {
        if (
          event.nativeEvent.target.scrollTop +
          event.nativeEvent.target.clientHeight ===
          event.nativeEvent.target.scrollHeight
        ) {
          // setOptions([
          //   ...options,
          //   { label: 'fake test', value: { pk: 'f01', name: 'fake test' } },
          // ]);
          // load more action
          loadMoreAction();
          setIsLoadMore(true);
        }
      }}
    >
      <Dropdown.Toggle as={CustomToggle} disableDropDown={disableDropDown}>
        <>
          {!!alwaysHint
            ? (
              <label
                className={'btn-link-text-label btn-link-text-label-active'}
              >
                {alwaysHint}
              </label>
            ) : (
              <label
                className={`btn-link-text-label ${displayValues ? 'btn-link-text-label-active' : ''
                  }`}
              >
                {displayValues || placeholder}
              </label>
            )
          }
          {hideDeleteButton ? null : (
            <Image
              src={deleteSelectedButton}
              className="filterable-dropdown-delete-selected"
              onClick={(e) => {
                e.stopPropagation();
                setValue('');
                onSelectChange({ value: null, label: null });
              }}
            />
          )}
          <Image
            src={NarrowUp}
            className={`filterable-toogle-area-indicator ${isOpen ? 'rtoate180' : ''
              }`}
          />
        </>
      </Dropdown.Toggle>

      <Dropdown.Menu
        as={CustomMenu}
        className="filterable-dropdown-menu"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          margin: 0,
          right: 'auto',
          bottom: 'auto',
        }}
        options={options}
        filter={needFilter}
        filterButtons={filterButtons}
        filterAction={filterAction}
        isLoadMore={setIsLoadMore}
        placeholder={dropDownSearchBarPlaceholder}
        useCaution={useCaution}
        cautionDetail={cautionDetail}
        isMultipleSelect={muitipleSelect}
      >
        {/* {muitipleSelect && displaySelectAllAsItem ?
          <Dropdown.Item
          >
            <CheckboxItem
              title={"All"}
              defaultValue={false}
              onChange={() => { }}
              needNoMargin={false}
            />
          </Dropdown.Item>
          : null} */}
        {options.map((option, index) => (
          <Dropdown.Item
            key={`${index}-${option.label}`}
            className="filterable-item"
            onSelect={(eventKey) => {
              if (!muitipleSelect) {
                onSelectChange(option);
                setValue(option.label);
                return;
              }
              let newValue = [];
              let selectValue = [];
              if (value?.indexOf(option.value?.pk) >= 0) {
                newValue = removeElementFromArray(value, option.value?.pk);
                selectValue = props.defaultValue.filter(
                  (item) => item.value?.pk !== option.value?.pk,
                );
              } else {
                newValue = [...value, option.value?.pk];
                selectValue = [...props.defaultValue, option];
              }
              setValue(newValue);
              onSelectChange(selectValue);
            }}
            disabled={option.disabled}
            eventKey={index}
          >
            {muitipleSelect ? (
              <CheckboxItem
                index={index}
                title={getOptionLabel(option)}
                defaultValue={value?.indexOf(option.value?.pk) >= 0}
                onChange={() => { }}
                needNoMargin={false}
              />
            ) : (
              getOptionLabel(option)
            )}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default FilterableDropdown;
